import { render, staticRenderFns } from "./WarningSection.vue?vue&type=template&id=33a2b422&scoped=true&"
import script from "./WarningSection.vue?vue&type=script&lang=js&"
export * from "./WarningSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33a2b422",
  null
  
)

export default component.exports